import { CCard } from './CCard.js';
import { CCardBody } from './CCardBody.js';
import { CCardFooter } from './CCardFooter.js';
import { CCardGroup } from './CCardGroup.js';
import { CCardHeader } from './CCardHeader.js';
import { CCardImage } from './CCardImage.js';
import { CCardImageOverlay } from './CCardImageOverlay.js';
import { CCardLink } from './CCardLink.js';
import { CCardSubtitle } from './CCardSubtitle.js';
import { CCardText } from './CCardText.js';
import { CCardTitle } from './CCardTitle.js';

const CCardPlugin = {
    install: (app) => {
        app.component(CCard.name, CCard);
        app.component(CCardBody.name, CCardBody);
        app.component(CCardFooter.name, CCardFooter);
        app.component(CCardGroup.name, CCardGroup);
        app.component(CCardHeader.name, CCardHeader);
        app.component(CCardImage.name, CCardImage);
        app.component(CCardImageOverlay.name, CCardImageOverlay);
        app.component(CCardLink.name, CCardLink);
        app.component(CCardSubtitle.name, CCardSubtitle);
        app.component(CCardText.name, CCardText);
        app.component(CCardTitle.name, CCardTitle);
    },
};

export { CCard, CCardBody, CCardFooter, CCardGroup, CCardHeader, CCardImage, CCardImageOverlay, CCardLink, CCardPlugin, CCardSubtitle, CCardText, CCardTitle };
//# sourceMappingURL=index.js.map
